// extracted by mini-css-extract-plugin
export const info = "python-module--info--oURly";